export default __webpack_public_path__ + "static/media/bup_logo.e8434154.png";